import { render, staticRenderFns } from "./MmDeliveryTransferEdit.vue?vue&type=template&id=64fcd641&scoped=true&"
import script from "./MmDeliveryTransferEdit.vue?vue&type=script&lang=js&"
export * from "./MmDeliveryTransferEdit.vue?vue&type=script&lang=js&"
import style0 from "./MmDeliveryTransferEdit.vue?vue&type=style&index=0&id=64fcd641&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcd641",
  null
  
)

export default component.exports